(function () {
    angular.module('tmx-app').controller('GuarantorLoanDialogController', ['$mdDialog', '$scope', 'guarantorData', 'showAddButton', 'guarantorTabEditPrivilege', 'tenantName','direction', 'ToastService', 'TMX_FINANCE_CONSTANTS', 'lookupService', 

        function GuarantorLoanDialogController($mdDialog, $scope, guarantorData, showAddButton, guarantorTabEditPrivilege, tenantName,direction, ToastService, TMX_FINANCE_CONSTANTS, lookupService) {
            $scope.vm = {};
            $scope.vm.guarantorData = {};
            $scope.vm.guarantorData.TmxGuarantor = {};
            $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorLoanDetail = {};
            $scope.vm.lookup = {};

            $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorLoanDetail = guarantorData;
            $scope.showOk = true;
            $scope.showAdd = showAddButton;
            $scope.guarantorTabEditPrivilege = guarantorTabEditPrivilege;
            $scope.direction=direction;

            if (tenantName == TMX_FINANCE_CONSTANTS.TENANTS.VITAS_EG) {
                $scope.isVitasEgyptTenant = true;
            }
            $scope.vm.lookup.LenderNames = lookupService.getLocalLookupsByType('Lender');


            $scope.ok = function (form) {
                form.$submitted = true;
                if (form.$valid) {
                    $mdDialog.hide();
                }
                else {
                    ToastService.showCustomToast("error", "Form Invalid.");
                }
            };
            $scope.add = function (form) {

                form.$submitted = true;
                if (form.$valid) {
                    $mdDialog.hide($scope.vm.guarantorData);
                }
                else {
                    ToastService.showCustomToast("error", "Form Invalid.");
                }

            };


            $scope.cancel = function () {
                $mdDialog.hide();
            };


        }]);
})();